export class TankType {
  public _id: string;
  public name: string;
  public isActive: boolean;
}
